export enum PolicyTypeFilter {
  Calendar = 'Calendar/PolicyType',
  Contact = 'Contacts/PolicyType',
  Drive = 'Drive/PolicyType',
  Mail = 'Mail/PolicyType',
  SharePoint = 'SharePoint/PolicyType',
  TeamDrives = 'TeamDrives/PolicyType'
}
